<nav class="navigation-wrapper">
  <div class="navigation-container">
    <div class="search-container" role="search" #searchContainer>
      <div class="search-wrapper">
        <i-feather name="search" class="search-icon"></i-feather>
        <div class="search-input-wrap">
          <input type="text" class="search-input"
            [placeholder]="'navRight.Search' | translate"
            aria-label="Search"
            [(ngModel)]="searchQuery" (input)="performSearch()" (focus)="onSearchFocus()" (blur)="onSearchBlur()"
            (keydown)="onKeyDown($event)" #searchInput />
        </div>
        <button
          *ngIf="showSpecFilterControl"
          type="button"
          class="search-spec-filter-btn"
          [disabled]="!showSpecFilterButton"
          [class.search-spec-filter-btn--active]="showSpecFilterButton && specFilterOpen"
          (click)="toggleSpecFilter()"
          [attr.aria-pressed]="showSpecFilterButton ? specFilterOpen : null"
          [title]="
            showSpecFilterButton
              ? ('CFproduct.openSpecificationFilter' | translate)
              : ('navRight.specFiltersUnavailable' | translate)
          ">
          <span class="search-spec-filter-btn__label">{{ 'navRight.specFilters' | translate }}</span>
          <i-feather name="filter" class="search-spec-filter-btn__icon"></i-feather>
        </button>
      </div>

      <div class="dropdown" *ngIf="searchResponse && searchQuery.length > 0 && !optionHidden && isSearchFocused">
        <div
          class="dropdown__scroll-hint dropdown__scroll-hint--top"
          *ngIf="showSearchScrollUp"
          aria-hidden="true">
          <svg class="dropdown__scroll-chevron" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5L6 1L11 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <div
          class="dropdown__list"
          #searchDropdownList
          (scroll)="onSearchDropdownScroll()">
        <ul>
          <!-- Products -->
          <li class="dropdown-item" *ngFor="let product of searchResponse.product; let i = index"
            [class.selected]="i === selectedIndex"
            (click)="navigateToResult({type: 'product', id: product.item, data: product})"
            (mouseenter)="selectedIndex = i"
            (pointerdown)="selectedIndex = i">
            <img class="dropdown-item__thumb"
                 [src]="product.image_url || 'assets/images/default.jpg'"
                 alt="Product Image"
                 (error)="$event.target.src='assets/images/default.jpg'"
                 (load)="$event.target.style.opacity='1'"
                 style="opacity: 0; transition: opacity 0.2s ease-in-out;" />
            <span class="search-result-text">{{
              product.searchKey1 ||
              product.General_Information?.searchKey1 ||
              product.item
            }}</span>
            <span class="result-type-badge product">{{'item' | translate}}</span>
            <a>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
                  fill="white" />
              </svg>
            </a>
            <i-feather name="chevron-right" class="dropdown-item__chevron" aria-hidden="true"></i-feather>
          </li>

          <!-- Sales Orders (Admin) -->
          <li class="dropdown-item" *ngFor="let order of searchResponse.salesOrder; let i = index"
            [class.selected]="i === selectedIndex"
            (click)="navigateToResult({type: 'salesOrder', id: order.salesOrderPortalID || order.salesOrderLN, data: order})"
            (mouseenter)="selectedIndex = i"
            (pointerdown)="selectedIndex = i">
            <i-feather name="shopping-bag" class="dropdown-item__icon"></i-feather>
            <span class="search-result-text">{{ order.salesOrderLN || order.salesOrderPortalID || '' }}</span>
            <span class="result-type-badge salesOrder">{{'ADCustomerCustomize.salesOrder' | translate}}</span>
            <a>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
                  fill="white" />
              </svg>
            </a>
            <i-feather name="chevron-right" class="dropdown-item__chevron" aria-hidden="true"></i-feather>
          </li>

          <!-- Business Partners (Admin) -->
          <li class="dropdown-item" *ngFor="let partner of searchResponse.businessPartner; let i = index"
            [class.selected]="i === selectedIndex"
            (click)="navigateToResult({type: 'businessPartner', id: partner.portalContactID || partner.customer, data: partner})"
            (mouseenter)="selectedIndex = i"
            (pointerdown)="selectedIndex = i">
            <i-feather name="award" class="dropdown-item__icon"></i-feather>
            <span class="search-result-text">{{ partner.name || partner.contact || partner.customer || partner.country || '' }}</span>
            <span class="result-type-badge businessPartner">{{'ADCustomerCustomize.BusinessPartner' | translate}}</span>
            <a>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
                  fill="white" />
              </svg>
            </a>
            <i-feather name="chevron-right" class="dropdown-item__chevron" aria-hidden="true"></i-feather>
          </li>

          <!-- Contacts (Admin) -->
          <li class="dropdown-item" *ngFor="let contact of searchResponse.contact; let i = index"
            [class.selected]="i === selectedIndex"
            (click)="navigateToResult({type: 'contact', id: contact.contact || contact.phoneNumber, data: contact})"
            (mouseenter)="selectedIndex = i"
            (pointerdown)="selectedIndex = i">
            <i-feather name="user-check" class="dropdown-item__icon"></i-feather>
            <span class="search-result-text">{{ contact.contact || contact.phoneNumber || '' }}</span>
            <span class="result-type-badge contact">{{'CONTACT' | translate}}</span>
            <a>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
                  fill="white" />
              </svg>
            </a>
            <i-feather name="chevron-right" class="dropdown-item__chevron" aria-hidden="true"></i-feather>
          </li>

          <!-- Customer Orders -->
          <li class="dropdown-item" *ngFor="let order of searchResponse.salesOrderCustomer; let i = index"
            [class.selected]="i === selectedIndex"
            (click)="navigateToResult({type: 'salesOrderCustomer', id: order.salesOrder, data: order})"
            (mouseenter)="selectedIndex = i"
            (pointerdown)="selectedIndex = i">
            <i-feather name="shopping-bag" class="dropdown-item__icon"></i-feather>
            <span class="search-result-text">{{ order.salesOrder || '' }}</span>
            <span class="result-type-badge salesOrderCustomer">{{'ADCustomerCustomize.salesOrder' | translate}}</span>
            <a>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
                  fill="white" />
              </svg>
            </a>
            <i-feather name="chevron-right" class="dropdown-item__chevron" aria-hidden="true"></i-feather>
          </li>

          <!-- Invoices -->
          <li class="dropdown-item" *ngFor="let invoice of searchResponse.invoice; let i = index"
            [class.selected]="i === selectedIndex"
            (click)="navigateToResult({type: 'invoice', id: invoice.invoiceId || invoice.orderId || invoice.status, data: invoice})"
            (mouseenter)="selectedIndex = i"
            (pointerdown)="selectedIndex = i">
            <i-feather name="dollar-sign" class="dropdown-item__icon"></i-feather>
            <span class="search-result-text">{{ invoice.invoiceId || invoice.orderId || invoice.status || '' }}</span>
            <span class="result-type-badge invoice">{{'CPInvoice.Invoice' | translate}}</span>
            <a>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
                  fill="white" />
              </svg>
            </a>
            <i-feather name="chevron-right" class="dropdown-item__chevron" aria-hidden="true"></i-feather>
          </li>

          <!-- Shipments -->
          <li class="dropdown-item" *ngFor="let shipment of searchResponse.shipment; let i = index"
            [class.selected]="i === selectedIndex"
            (click)="navigateToResult({type: 'shipment', id: shipment.shipmentId || shipment.invoiceNumber || shipment.status, data: shipment})"
            (mouseenter)="selectedIndex = i"
            (pointerdown)="selectedIndex = i">
            <i-feather name="truck" class="dropdown-item__icon"></i-feather>
            <span class="search-result-text">{{ shipment.shipmentId || '' }}</span>
            <span class="result-type-badge shipment">{{'CFDashboard.Shipment' | translate}}</span>
            <a>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.83333 3V4.33333H11.2267L3.5 12.06L4.44 13L12.1667 5.27333V9.66667H13.5V3H6.83333Z"
                  fill="white" />
              </svg>
            </a>
            <i-feather name="chevron-right" class="dropdown-item__chevron" aria-hidden="true"></i-feather>
          </li>
        </ul>
        </div>

        <div
          class="dropdown__scroll-hint dropdown__scroll-hint--bottom"
          *ngIf="showSearchScrollDown"
          aria-hidden="true">
          <svg class="dropdown__scroll-chevron" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 5L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="header-toolbar__actions">
      <div class="nav-left header-toolbar__language">
        <div class="language-dropdown">
          <!-- Dropdown trigger button -->
          <button class="language-dropdown-btn" (click)="toggleDropdownLanguage($event)" type="button">
            <span class="language-dropdown-btn__label">
              {{ selectedLanguage | uppercase }}
            </span>
            <i-feather
              [name]="isDropdownOpenLang ? 'chevron-up' : 'chevron-down'"
              class="language-dropdown-btn__chevron"></i-feather>
          </button>

          <!-- Dropdown content -->
          <div class="language-dropdown-content" [ngClass]="{'show': isDropdownOpenLang}">
            <ng-container *ngFor="let language of languageList">
              <a *ngIf="language.status === 'active'" class="language-item"
                [class.active]="isLanguageSelected(language.code)" (click)="changeSiteLanguage(language.code)">
                <img src="assets/svg-country-flags/svg/{{language.code === 'en' ? 'us' :  language.code}}.svg"
                  alt="{{getLanguageNameKey(language.code) | translate}} flag" class="flag-icon">
                {{ getLanguageNameKey(language.code) | translate }}
                <i-feather *ngIf="isLanguageSelected(language.code)" name="check" class="check-mark"></i-feather>
              </a>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Right section -->
      <div class="nav-right">
      <div class="cart-container" *ngIf="isCustomer" [routerLink]="['shopping-basket']">
        <i-feather name="shopping-cart"   [title]="'TFNotification.BasketList' | translate"></i-feather>
        <!-- <img src="/assets/images/cart-icon.svg" alt="cart" class="img" /> -->
        <span class="cart-counter" *ngIf="cartItemCount > 0">{{ cartItemCount }}</span>
      </div>
      <div class="notification-container">
        <app-notification-bell placement="header" [viewAllRoute]="['/tf/notifications']"></app-notification-bell>
      </div>


      <!-- </button> -->
      <div class="profile-dropdown">
        <button class="profile-dropdown-btn" (click)="toggleDropdown($event)" type="button">
          <img [src]="pictureUrl" alt="User profile" class="profile-img">
          <span class="profile-dropdown-btn__info">
            <span class="profile-dropdown-btn__name-row">
              <span class="profile-dropdown-btn__name">{{ username }}</span>
              <i-feather
                [name]="isDropdownOpen ? 'chevron-up' : 'chevron-down'"
                class="profile-dropdown-btn__chevron"></i-feather>
            </span>
            <span class="profile-dropdown-btn__role">{{ group }}</span>
          </span>
        </button>

        <div class="profile-dropdown-content" [ngClass]="{'show': isDropdownOpen}">
          <button type="button" class="profile-item" (click)="navigateAndCloseProfile('/tf/navigationprofile')">
            <i-feather name="settings" class="profile-item-icon"></i-feather>
            <span>{{"navRight.AccountSettings"|translate}}</span>
          </button>
          <button type="button" class="profile-item" (click)="navigateAndCloseProfile('/help')">
            <i-feather name="help-circle" class="profile-item-icon"></i-feather>
            <span>{{"navRight.Help"|translate}}</span>
          </button>
          <button type="button" class="profile-item" (click)="isDropdownOpen = false; logout()">
            <i-feather name="log-out" class="profile-item-icon"></i-feather>
            <span>{{"navRight.LogOut"|translate}}</span>
          </button>
        </div>
      </div>
    </div>
    </div>

  </div>
</nav>